export default "__VITE_ASSET__CSw5Lwjy__"